import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Equipment from '../components/Equipment';
import WhyChoose from '../components/WhyChoose';
import Testimonial from '../components/Testimonial';
import Footer from '../components/Footer';
import useSEO from '../hooks/useSEO';

const homeSchema = [
    {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://www.primerehabindustries.in/#organization",
        "name": "Prime Rehab Industries",
        "url": "https://www.primerehabindustries.in/",
        "logo": "https://www.primerehabindustries.in/Image/Logo.png",
        "telephone": "+91-99943-51947",
        "email": "primerehaboffl@gmail.com"
    },
    {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": "https://www.primerehabindustries.in/#localbusiness",
        "name": "Prime Rehab Industries",
        "image": "https://www.primerehabindustries.in/Image/Logo.png",
        "url": "https://www.primerehabindustries.in/",
        "telephone": "+91-99943-51947",
        "email": "primerehaboffl@gmail.com",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Plot No: 4, Kandasamy Nagar Annex, Vanagaram",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "postalCode": "600095",
            "addressCountry": "IN"
        },
        "areaServed": ["Chennai", "Tamil Nadu", "India"]
    },
    {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "url": "https://www.primerehabindustries.in/",
        "name": "Prime Rehab Industries"
    }
];

const HomePage = () => {
    useSEO({
        title: "Prime Rehab Industries | Physiotherapy & Rehabilitation Equipment Manufacturer, Chennai",
        description: "Prime Rehab Industries manufactures physiotherapy, chiropractic and rehabilitation equipment in Chennai, Tamil Nadu — traction tables, tilting tables, unweighing systems and mobility aids for clinics and hospitals across India.",
        canonical: "https://www.primerehabindustries.in/",
        schema: homeSchema
    });

    return (
        <div className="home-page">
            <Navbar />
            <Hero />
            <About />
            <Equipment />
            <WhyChoose />
            <Testimonial />
            <Footer />
        </div>
    );
};

export default HomePage;
